import { gsap, MotionPathPlugin } from "gsap/all";
import { useEffect } from 'react';

/**
 * For when we have an object that should follow a path. Tied to the user's scroll position.
 * @param {*} props 
 * @returns 
 */

function Key2({animate}) {
    gsap.registerPlugin(MotionPathPlugin);

    useEffect(() => {
      const pathElem = document.querySelector("#path2");
      const offsetFromTop = window.innerHeight * 0.3;
      const pathBB = pathElem.getBoundingClientRect();
      const startY = pathBB.top + window.scrollY - offsetFromTop - 500;
     // const startY = document.querySelector("#path1").offsetTop - window.innerHeight + offsetFromTop;
      const finishDistance = 800;

      const tween = gsap.to("#key2", {
        duration: 50,
        paused: true,
        progress: animate ? 0.1 : 0.5,
        repeat: 0,
        keyframes: [
          { motionPath: {
            path: "#path2",
            align: "#path2",
            alignOrigin: [0.3, 0.15],
            autoRotate: 0,
            //autoRotate: 180,
            start: 0.1
          }
        }, {opacity: 0}
        ],
         ease:"none"
      });

      let requestId = null;
     // document.addEventListener("scroll", handleScroll);
      
      if (animate) {
        document.addEventListener("scroll", handleScroll);
        tween.progress(( window.scrollY - startY) / finishDistance);
      } else {
        document.removeEventListener("scroll", handleScroll);
        tween.progress(0.5);
      }

      function handleScroll() {
        

        if (!requestId) {
          requestId = requestAnimationFrame(update);
        }
      }

      function update() {
        // Update our animation
        
        if (animate) {
          tween.progress(( window.scrollY - startY) / finishDistance);
        } else {
          tween.progress(0.5);
        }
        // Let the scroll event fire again
        requestId = null;
      }
      return () => document.removeEventListener("scroll", handleScroll);
    }, [animate]);
   return (
     <div className="pathcontainer key2-container">
      <svg className="key2" xmlns="http://www.w3.org/2000/svg" width="414.398" height="406.612" viewBox="0 0 414.398 406.612">
         <image  href="/ReactAssets/CustomerJourney/keypaths/desktop/Key.svg" id="key2" width="80" height="80" data-svg-origin="24 12" transform="matrix(-0.46016,-0.88784,0.88784,-0.46016,395.23724,345.90208)" style={{transformOrigin: '0px 0px'}}/>
         <path stroke-dasharray="10 14" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" stroke="#a29064" fill="none" d="m414.00298,371.14839c-12.15073,-83.00416 -91.659,-124.941 -195.71846,-154.61556s-206.29287,-71.69527 -216.7913,-171.18035" data-name="Path 2" id="path2"/>
      </svg>


    </div>
   );
 }
 
 export default Key2;
